import * as Sentry from "@sentry/react";

/**
 * Report a wizard error to Sentry. The wizard surfaces most failures only as a
 * toast or inline message, so without this they never reach error tracking.
 * `where` names the failing operation (e.g. "autosave"); `context` carries
 * triage fields (identifier, dvr id, step…).
 */
export function captureWizardError(err, where, context = {}) {
  const status = err?.response?.status;
  Sentry.captureException(err, {
    // 4xx is usually a validation/user issue; 5xx and network failures are ours.
    level: status >= 400 && status < 500 ? "warning" : "error",
    tags: { wizard_op: where, ...(status ? { http_status: String(status) } : {}) },
    contexts: { wizard: { where, ...context } },
  });
}

/**
 * Leave a breadcrumb for a wizard step transition, so a later captured error
 * carries the trail of steps that led to it.
 */
export function breadcrumbStepChange(from, to, identifier) {
  Sentry.addBreadcrumb({
    category: "wizard",
    message: `step ${from ?? "?"} → ${to ?? "?"}`,
    level: "info",
    data: { identifier, from, to },
  });
}
